// Page Title: Salesforce Object Synchronization

import { AiOutlineForm } from "react-icons/ai";
import { MdGroups, MdOutlineAccountBox, MdOutlineEventSeat, MdOutlineShoppingCart, MdOutlineSync } from "react-icons/md";

export const salesforceData = [
    {
        title: "Synchronize Objects (Cases) to WordPress Custom Post Type",
        video: true,
        videoId: "Rrda9VsF0EE",
        videoType: "youtube",
        icon: <MdOutlineSync className='text-white fs-5' />
    },
    {
        title: "WooCommerce Manager (Products / Orders / Customers Sync)",
        video: true,
        videoId: "BSgxjwybqko",
        videoType: "youtube",
        icon: <MdOutlineShoppingCart className='text-white fs-5' />
    },
    {
        title: "Seamless Event Management: Sync Events from Salesforce to WordPress",
        video: true,
        videoId: "TAm_RjHt0cQ",
        videoType: "youtube",
        icon: <MdOutlineEventSeat className='text-white fs-5' />
    },
    {
        title: "Form builder Integrations (WP Forms, Gravity Forms, Contact Form 7, etc.)",
        video: false,
        videoId: "",
        videoType: "",
        icon: <AiOutlineForm className='text-white fs-5' />
    },
    {
        title: "User / Role exception/Inclusion",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdGroups className='text-white fs-5' />
    }
]